import { PortalLink } from 'src/components/Buttons';
import styled from 'styled-components';
import { mediaMaxWidth2 } from '../../../../../../styles';

export const MandatesLink = styled(PortalLink)`
  margin-right: 12px;

  ${mediaMaxWidth2.tabletSmall`
    width: 100%;
    margin-bottom: 12px;
    margin-right: 0;
 `}
`;
